import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

const ModalCropImage = (props) => {
  const { t } = useTranslation();
  const { show, handleClose, image, setImageCropped, resetImage, xRatio, yRatio } = props;
  const [crop, setCrop] = useState({ aspect: xRatio / yRatio });
  const [completedCrop, setCompletedCrop] = useState(null);
  const imgRef = useRef(null);

  // Réinitialise la fenetre de crop à chaque qu'une image est chargé dans le module.
  useEffect(() => {
    setCrop({ aspect: xRatio / yRatio });
  }, [image]);

  // Dés que l'image est chargé on set la réference.
  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  /**
   * Fontion permettant de renvoyer l'image au format blob à partir de l'image et du crop.
   * @param {HTMLImageElement} image - Image File Object
   * @param {Object} crop - crop Object
   * @param {String} fileName - Name of the returned file in Promise
   */
  const getCroppedImg = (image, crop, fileName) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          blob.name = fileName;
          resolve(blob);
        },
        "image/jpeg",
        1
      );
    });
  };

  const cropImage = async () => {
    const img = await getCroppedImg(imgRef.current, completedCrop, "image-avatar.jpeg");
    setImageCropped(img);
    handleClose();
  };

  const closeModal = () => {
    resetImage();
    handleClose();
  };

  return (
    <Modal size="xl" show={show} onHide={closeModal}>
      {/* <pre>{JSON.stringify(crop, null, 4)}</pre> */}
      <Modal.Header closeButton>
        <Modal.Title>{t("admin.PageAdminCollaborateurs.ajuster")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ReactCrop
          src={image}
          ruleOfThirds
          crop={crop}
          onImageLoaded={onLoad}
          onChange={(c) => setCrop(c)}
          onComplete={(c) => setCompletedCrop(c)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={closeModal}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button
          disabled={crop.width === 0 && crop.height === 0}
          variant="success"
          onClick={() => cropImage()}
        >
          {t("commun.form.button.confirmer")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCropImage;
